import React, { useEffect, useState } from 'react';
import { Avatar, Badge, Button, Divider, Dropdown, List, Space } from 'antd';
import { Bell, BellRingIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../../style/component.css';
import { useDispatch, useSelector } from 'react-redux';
import { getNotifications, markReadNotifications } from '../../feature/notification/NotificationSlice';




const Notifications = () => {
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const { notifications } = useSelector((state) => state.notifications)

    const notificationRoutes = {
        WEBSITE_ENQUIRY: "/dashboard/daycare",
    };


    const handleClick = async (id, type, isRead) => {
        const route = notificationRoutes[type];

        if (!route) return;

        try {
            if (!isRead) {
                const resultAction = await dispatch(
                    markReadNotifications({ notificationId: id })
                );

                if (!markReadNotifications.fulfilled.match(resultAction)) {
                    return;
                }

                dispatch(getNotifications());
            }

            navigate(route);
            setOpen(false);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        dispatch(getNotifications())
    }, [open])

    console.log("notifications", notifications)

    const menuOverlay = (
        <div
            className='notificationContainer'
        >
            <Space>
                <h3>Notifications</h3>
                <Badge count={notifications?.length}>
                </Badge>
            </Space>
            <Divider style={{marginBottom:0}}/>
            <List
                itemLayout="horizontal"
                size='medium'
                dataSource={notifications}
                renderItem={(item, index) => (
                    <List.Item onClick={() => handleClick(item._id, item.type, item.isRead)}>
                        <List.Item.Meta
                            avatar={<Avatar size={30} icon={item.isRead ? <BellRingIcon color='black' size={14} /> : <Badge dot   ><BellRingIcon color='black' size={14} /></Badge>} />}
                            title={<div className={`${item.isRead ? "noteTitle" : ""}`}>
                                <span>{item.title}</span>
                            </div>}
                            description={<div className='notification'>
                                <small>{item.body}</small>
                                <small>{item.addedDate}</small>
                            </div>}
                        />
                    </List.Item>
                )}
            />
            
        </div>
    );

    return (
        <Dropdown
            overlay={menuOverlay}
            trigger={['click']}
            placement="bottomRight"
            open={open}
            onOpenChange={setOpen}
            arrow
        >
            <Button type='link' icon={<Bell color="black" size={20} className="icons" />}>
            </Button>
        </Dropdown>
    );
};

export default Notifications;
